import script from "./GameTimer.vue?vue&type=script&setup=true&lang=js"
export * from "./GameTimer.vue?vue&type=script&setup=true&lang=js"

import "../styles/_timer.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__